import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_STATUS } from "../../constants";
import { GetSingleUser } from "../../apis/user/get_single_user";
import HeaderMenu from "../sidebar/headermenu";
import PlaceHolder from "../../utils/placeholder";
import { useDispatch, useSelector } from "react-redux";
import { reloadState } from "../../redux/GlobalSlice";
import ClientEventWrap from "../events/client_event_wrap";
import ApproachList from "./approach_list";
import Approach from "./approach";
import PostImages from "./post_images";
import PostVideos from "./post_videos";
import ClientApproaches from "./client_approaches";
import { GetLinksApi } from "../../apis/user/get_links_api";
import CompanyProfile from "./company_profile";
import { FacebookIcon, WhatsappIcon, EmailIcon, TwitterIcon, TelegramIcon, InstapaperIcon, LinkedinIcon, XIcon, FacebookMessengerIcon, PinterestIcon } from "react-share";
import { FacebookShareButton, WhatsappShareButton, EmailShareButton, LinkedinShareButton, TwitterShareButton, TelegramShareButton, InstapaperShareButton, FacebookMessengerShareButton, PinterestShareButton } from "react-share";
import { GetBasicUser } from "../../apis/user/get_basic_user";
import LoginModel from "../login/login_model";
import DummyMenu from "../sidebar/dummymenu";
import { QRCodeCanvas } from "qrcode.react";
import html2canvas from "html2canvas";
import favicon from '../../assets/images/favicon.png';
import orange_and_black_new from '../../assets/images/qr_logo.png';
import ClientAdPostWrap from "../posts/client_adpost_wrap";
import ArtistMedia from "./artist_media";

export default function Profile() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const globalState = useSelector(state => state.globalstate);

    const params = useParams({ userId: String });
    const [userData, setUserData] = useState('');
    const [loginId, setLoginId] = useState('');
    const [userType, setUserType] = useState('');
    const [loginType, setLoginType] = useState('');
    const [postCount, setPostCount] = useState('0');
    const [eventCount, setEventCount] = useState('0');
    const [activeTab, setTab] = useState('post_image');
    const [appTab, setAppTab] = useState(false);
    const [links, setLinks] = useState([]);
    const [getLinks, setGetlink] = useState(API_STATUS);
    const [loginSub, setLoginSub] = useState(false);
    const [viewProfile, setViewProfile] = useState(false);
    const [videoKyc, setVideoKyc] = useState(false);


    const [userApi, setUserApi] = useState(API_STATUS);

    const [qrValue, setQrValue] = useState('https://website.filmwings.com/profile/' + params.userId);
    const qrCodeRef = useRef(null);
    const [shareUrl, setShareUrl] = useState('https://website.filmwings.com/profile/' + params.userId);
    const [shareTitle, setShareTitle] = useState('Filmwings artist profile');
    const [shareBox, setShareBox] = useState(false);
    const [shareSocial, setShareSocial] = useState(false);

    const [login, setLogin] = useState(false);

    useEffect(() => {
        const token = sessionStorage.getItem('LOGIN_TOKEN');
        if (token == null) {
            // navigate('/login');
            setLogin(false);
            GetBasicUser(params.userId, setUserApi);
        } else {
            setLogin(true);
            intiPage();
        }
    }, []);

    const intiPage = () => {
        setUserData('');
        const userCode = sessionStorage.getItem('USER_CODE');
        setLoginId(userCode);

        const utype = sessionStorage.getItem('USER_TYPE');
        setLoginType(utype);

        getUserData();
        GetLinksApi(params.userId, setGetlink);

        const loginData = sessionStorage.getItem('LOGIN_DATA');
        const logingUser = JSON.parse(loginData);

        if (logingUser['liveness'] === 1) {
            setVideoKyc(true);
        } else {
            setVideoKyc(false);
        }

        if (logingUser['subPayStatus'] !== null) {
            if (logingUser['subPayStatus'] === 1) {
                setLoginSub(true);
            }
        }
    }

    const getUserData = () => {
        GetSingleUser(params.userId, setUserApi);
    }

    useEffect(() => {
        if (!getLinks.isError && !getLinks.isLoader && getLinks.data != null) {
            let res = getLinks.data;
            setLinks(res.data);
        }
    }, [getLinks]);

    useEffect(() => {
        if (!userApi.isLoader && !userApi.isError && userApi.data !== null) {
            let res = userApi.data;
            setUserData(res.data);
            setShareTitle(res.data['firstName'] + ' ' + res.data['lastName']);
            setUserType(res.data['userType']);
            if (res.data['userType'] === 1) {
                setTab('events');
            }
        }
    }, [userApi]);

    const navEditProfile = () => {
        navigate('/edit_profile', { state: { userData: userData } });
    }

    const navCreateArtist = () => {
        navigate('/create_artist_profile', { state: { userData: userData } });
    }

    const navSubPayment = () => {
        navigate('/sub_payment/' + userData['subId']);
    }

    const navArtistProfile = () => {
        navigate('/artist_profile/' + userData['userId']);
    }

    const navMessage = () => {
        navigate('/message_users', { state: { userData: userData } });
    }

    const navBoostProfile = () => {
        navigate('/boost_profile');
    }

    useEffect(() => {
        if (globalState.reaload_profile) {
            getUserData();
            dispatch(reloadState({ 'reaload_profile': false }));
        }
    }, [globalState]);

    const _saveShare = () => { }

    const downloadQRCode = () => {
        if (qrCodeRef.current) {
            html2canvas(qrCodeRef.current).then((canvas) => {
                const link = document.createElement('a');
                link.href = canvas.toDataURL('image/png');
                link.download = "filmwing_profile.png";
                link.click();
            })
        }
    };

    return <div id="wrapper">
        {
            login &&
            <HeaderMenu />
        }
        {
            !login &&
            <DummyMenu />
        }
        <main className="2xl:ml-[--w-side] xl:ml-[--w-side-md] md:ml-[--w-side-small]">
            {
                viewProfile && login &&
                <CompanyProfile userData={userData} links={links} setViewProfile={setViewProfile} />
            }
            {
                !viewProfile &&

                <div className="main__inner">
                    {
                        userApi.isLoader &&
                        <PlaceHolder />
                    }
                    {
                        !userApi.isLoader && userData !== "" && userData !== null &&

                        <div className="py-6 relative">

                            <div className="flex md:gap-16 gap-4 max-md:flex-col">
                                <div className="relative md:p-1 rounded-full h-full max-md:w-16 bg-gradient-to-tr from-pink-400 to-pink-600 shadow-md hover:scale-110 duration-500 uk-animation-scale-up">
                                    <div className="relative md:w-40 md:h-40 h-16 w-16 rounded-full overflow-hidden md:border-[6px] border-gray-100 shrink-0 dark:border-slate-900">
                                        <img src={userData['userPic']} alt="" className="w-full h-full absolute object-cover" />
                                    </div>
                                    {/* <button type="button" className="absolute -bottom-2 left-1/2 -translate-x-1/2 bg-white shadow p-1.5 rounded-full sm:flex hidden">
                                    <ion-icon name="camera" className="text-2xl">
                                        <i className="fa fa-camera"></i>
                                    </ion-icon>
                                </button> */}
                                </div>


                                <div className="max-w-2x flex-1">
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <h3 className="md:text-xl text-base font-semibold text-black dark:text-white"> {userData['username']} </h3>
                                        {
                                            userData['subId'] != null && userData['subPayStatus'] == 1 &&
                                            <span style={{ color: '#17ce85ff', fontSize: 16 }}><i class="fa fa-check-circle" aria-hidden="true"></i></span>
                                        }
                                    </div>


                                    <p className="sm:text-sm text-blue-600 mt-1 font-normal text-xs">{userData['firstName']} {userData['lastName']}</p>
                                    {
                                        userData['city'] !== "" &&
                                        <div>
                                            <b>{userData['city']}</b>
                                        </div>
                                    }
                                    <p className="text-sm mt-2 md:font-normal font-light">

                                        {userData['about']}
                                        {
                                            (userData['about'] == null || userData['city'] === "") && userData['userId'] === loginId &&
                                            <button onClick={navEditProfile} className="bg-secondery font-semibold px-4 py-1.5 rounded-lg text-sm border1"> Complete Profile </button>
                                        }
                                    </p>

                                    {
                                        links.length > 0 &&
                                        <div className="text-sm text-blue-600 mt-2 md:font-normal font-light">
                                            {
                                                links.map((item, i) =>
                                                    <p key={i}>
                                                        <i class="fa fa-link" aria-hidden="true"></i> <a href={item.ul_link}>{item.ul_title}</a>
                                                    </p>
                                                )
                                            }
                                            {
                                                userData['userId'] === loginId &&
                                                <p className="mt-2"><Link to={'/social_links'} className="sm:text-sm text-blue-600 font-normal text-xs">Manage Links</Link></p>
                                            }
                                        </div>
                                    }
                                    {
                                        links.length === 0 && userData['userId'] === loginId &&
                                        <p><Link to={'/social_links'} className="sm:text-sm text-blue-600 mt-1 font-normal text-xs">Add Links</Link></p>
                                    }

                                    <p className="mt-2 space-x-2 text-gray-500 text-sm hidden" style={{ marginTop: 11 }}><a href="/" className="inline-block">Travel</a> . <a href="/" className="inline-block">Business</a> . <a href="/" className="inline-block">Technolgy</a>  </p>
                                    {
                                        userData['userType'] === 0 && login &&

                                        <div className="flex md:items-end justify-between md:mt-8 mt-4 max-md:flex-col gap-4">
                                            <div className="flex sm:gap-10 gap-6 sm:text-sm text-xs max-sm:absolute max-sm:top-10 max-sm:left-36">
                                                <div>
                                                    <p>Posts</p>
                                                    <h3 className="sm:text-xl sm:font-bold mt-1 text-black dark:text-white text-base font-normal">{postCount}</h3>
                                                </div>
                                                {
                                                    userData['userId'] !== loginId && userData['subId'] !== null && userData['subPayStatus'] === 1 && (loginSub || loginType === '1') &&
                                                    <div style={{ alignContent: 'center' }}>
                                                        <button onClick={navMessage} type="button" className="button bg-pink-600 text-white">Message</button>
                                                    </div>
                                                }

                                            </div>
                                            <div className="flex items-center gap-3 text-sm">

                                                {
                                                    userData['subId'] === null && userData['userId'] === loginId &&

                                                    <button onClick={navCreateArtist} className="button bg-pink-100 text-pink-600 border border-pink-200">Portfolio</button>

                                                }
                                                {
                                                    userData['subId'] !== null && userData['subPayStatus'] === 1 &&

                                                    <button onClick={navArtistProfile} className="button bg-pink-100 text-pink-600 border border-pink-200">Portfolio</button>
                                                }
                                                {
                                                    (userData['subId'] !== null && userData['subPayStatus'] === 0 && userData['userId'] === loginId) ?
                                                        <div className="text-center">
                                                            1 Step away to complete portfolio<br />
                                                            <button onClick={navSubPayment} className="button bg-pink-100 text-pink-600 border border-pink-200">Complete Now</button>
                                                        </div> : <div>
                                                            {
                                                                userData['userId'] !== loginId && userData['shareProfile'] === 1 &&
                                                                <Link
                                                                    onClick={() => setShareBox(!shareBox)}
                                                                    className="button bg-blue-100 text-blue-600 border border-blue-200" style={{ marginRight: 12 }}>Share Profile</Link>
                                                            }
                                                            {
                                                                userData['userId'] === loginId &&
                                                                <Link
                                                                    onClick={() => setShareBox(!shareBox)}
                                                                    className="button bg-blue-100 text-blue-600 border border-blue-200" style={{ marginRight: 12 }}>Share Profile</Link>
                                                            }
                                                            {
                                                                loginType === '1' && userData['subId'] !== null && userData['subPayStatus'] === 1 &&
                                                                <Link
                                                                    onClick={() => {
                                                                        if (videoKyc) {
                                                                            setAppTab(true);
                                                                        } else {
                                                                            navigate("/video_kyc_pending");
                                                                        }
                                                                    }}
                                                                    className="button bg-blue-100 text-blue-600 border border-blue-200">Approach</Link>
                                                            }
                                                        </div>
                                                }

                                            </div>

                                        </div>
                                    }
                                    {
                                        shareBox &&

                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, flexDirection: 'column' }}>
                                            <div style={{ backgroundColor: '#ffffff', borderRadius: 10, padding: 10 }}>
                                                <QRCodeCanvas
                                                    ref={qrCodeRef}
                                                    value={qrValue}
                                                    size={220}
                                                    level={"M"}
                                                    title="Filmwings"
                                                    marginSize={2}
                                                    fgColor={'#224a64ff'}
                                                    imageSettings={{
                                                        src: orange_and_black_new,
                                                        height: 20,
                                                        width: 107,
                                                        excavate: true
                                                    }}
                                                ></QRCodeCanvas>
                                            </div>
                                            <div className="p-1 mt-2 bg-white" style={{ borderRadius: 10, padding: 10, display: 'flex', justifyContent: 'space-between', width: 240 }}>
                                                <div style={{ textAlign: 'center' }}>
                                                    <Link className="button text-blue-600 border border-blue-200" onClick={() => setShareSocial(!shareSocial)}><i class="fa fa-share-alt" aria-hidden="true"></i></Link>
                                                    <div className="text-xs mt-3">Share</div>
                                                </div>
                                                <div style={{ textAlign: 'center' }}>
                                                    <Link onClick={() => {
                                                        navigator.clipboard.writeText(qrValue);
                                                    }} className="button text-blue-600 border border-blue-200"><i class="fa fa-link" aria-hidden="true"></i></Link>
                                                    <div className="text-xs mt-3">Copy</div>
                                                </div>
                                                <div style={{ textAlign: 'center' }}>
                                                    <Link className="button text-blue-600 border border-blue-200" onClick={downloadQRCode}><i class="fa fa-download" aria-hidden="true"></i></Link>
                                                    <div className="text-xs mt-3">Download</div>
                                                </div>
                                            </div>

                                            {
                                                shareSocial &&

                                                <div style={{ paddingRight: 10, textAlign: 'right' }}>

                                                    <div>
                                                        <FacebookShareButton
                                                            url={shareUrl}
                                                            title={shareTitle}
                                                            onShareWindowClose={_saveShare}
                                                            style={{ marginRight: 5 }}>
                                                            <FacebookIcon round={true} size={30} />
                                                        </FacebookShareButton>

                                                        <FacebookMessengerShareButton
                                                            url={shareUrl}
                                                            title={shareTitle}
                                                            onShareWindowClose={_saveShare}
                                                            style={{ marginRight: 5 }}>
                                                            <FacebookMessengerIcon round={true} size={30} />
                                                        </FacebookMessengerShareButton>

                                                        <WhatsappShareButton
                                                            url={shareUrl}
                                                            title={shareTitle}
                                                            onShareWindowClose={_saveShare}
                                                            style={{ marginRight: 5 }}>
                                                            <WhatsappIcon round={true} size={30} />
                                                        </WhatsappShareButton>

                                                        <EmailShareButton
                                                            url={shareUrl}
                                                            title={shareTitle}
                                                            onShareWindowClose={_saveShare}
                                                            style={{ marginRight: 5 }}>
                                                            <EmailIcon round={true} size={30} />
                                                        </EmailShareButton>

                                                        <LinkedinShareButton
                                                            url={shareUrl}
                                                            title={shareTitle}
                                                            onShareWindowClose={_saveShare}
                                                            style={{ marginRight: 5 }}>
                                                            <LinkedinIcon round={true} size={30} />
                                                        </LinkedinShareButton>

                                                        <TwitterShareButton
                                                            url={shareUrl}
                                                            title={shareTitle}
                                                            onShareWindowClose={_saveShare}
                                                            style={{ marginRight: 5 }}>
                                                            <XIcon round={true} size={30} />
                                                        </TwitterShareButton>

                                                        <TelegramShareButton
                                                            url={shareUrl}
                                                            title={shareTitle}
                                                            onShareWindowClose={_saveShare}
                                                            style={{ marginRight: 5 }}>
                                                            <TelegramIcon round={true} size={30} />
                                                        </TelegramShareButton>

                                                        <InstapaperShareButton
                                                            url={shareUrl}
                                                            title={shareTitle}
                                                            onShareWindowClose={_saveShare}
                                                            style={{ marginRight: 5 }}>
                                                            <InstapaperIcon round={true} size={30} />
                                                        </InstapaperShareButton>

                                                        <PinterestShareButton
                                                            url={shareUrl}
                                                            title={shareTitle}
                                                            onShareWindowClose={_saveShare}
                                                            style={{ marginRight: 5 }}>
                                                            <PinterestIcon round={true} size={30} />
                                                        </PinterestShareButton>
                                                    </div>
                                                </div>
                                            }

                                        </div>
                                    }

                                    {
                                        userData['userType'] === 1 && login &&

                                        <div className="flex md:items-end justify-between md:mt-8 mt-4 max-md:flex-col gap-4">
                                            <div className="flex sm:gap-10 gap-6 sm:text-sm text-xs max-sm:absolute max-sm:top-10 max-sm:left-36">
                                                <div>
                                                    <p>Events</p>
                                                    <h3 className="sm:text-xl sm:font-bold mt-1 text-black dark:text-white text-base font-normal">{eventCount}</h3>
                                                </div>
                                                {
                                                    userData['userId'] === loginId &&
                                                    <div style={{ alignContent: 'center' }}>
                                                        <a href="/create_event" className="button bg-pink-600 text-white">Create Event</a>
                                                    </div>
                                                }
                                                {
                                                    userData['userId'] !== loginId && (loginSub || loginType === '1') &&
                                                    <div style={{ alignContent: 'center' }}>
                                                        <button onClick={navMessage} type="button" className="button bg-pink-600 text-white">Message</button>
                                                    </div>
                                                }
                                                {
                                                    ((userData['userId'] !== loginId && loginSub) || userData['userId'] === loginId) &&
                                                    <div style={{ alignContent: 'center' }}>
                                                        <button onClick={() => {
                                                            setViewProfile(true);
                                                        }} type="button" className="button bg-pink-100 text-pink-600 border border-pink-200">View Profile</button>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }

                                </div>
                            </div>

                        </div>
                    }

                    {
                        userData['userType'] === 0 && login &&

                        <div className="mt-10">
                            {
                                appTab &&
                                <Approach userId={userData['userId']} setAppTab={setAppTab} />
                            }
                            {
                                !appTab &&
                                <div className="mt-10">
                                    <div uk-sticky="cls-active: bg-slate-100/60 z-30 backdrop-blur-lg px-4 dark:bg-slate-800/60; start: 500; animation: uk-animation-slide-top" className="uk-sticky">

                                        <nav className="text-sm text-center text-gray-500 capitalize font-semibold dark:text-white">
                                            <ul className="flex gap-2 justify-center border-t dark:border-slate-700" uk-switcher="connect: #story_tab ; animation: uk-animation-fade, uk-animation-slide-left-medium">

                                                <li className="uk-active"> <a href=""
                                                    onClick={() => {
                                                        setTab('post_image');
                                                    }}
                                                    className="flex items-center p-4 py-2.5 -mb-px border-t-2 border-transparent aria-expanded:text-black aria-expanded:border-black aria-expanded:dark:text-white aria-expanded:dark:border-white" aria-expanded="true"> <ion-icon className="mr-2 text-2xl" name="camera-outline"></ion-icon> Posts  </a> </li>
                                                <li
                                                    onClick={() => {
                                                        setTab('post_video');
                                                    }}
                                                    className=""> <a href="" className="flex items-center p-4 py-2.5 -mb-px border-t-2 border-transparent aria-expanded:text-black aria-expanded:border-black aria-expanded:dark:text-white aria-expanded:dark:border-white" aria-expanded="false"> <ion-icon className="mr-2 text-2xl" name="play-outline"></ion-icon> Videos </a> </li>
                                                {
                                                    userData['userId'] === loginId &&

                                                    <li
                                                        onClick={() => {
                                                            if (videoKyc) {
                                                                setTab('client_approache');
                                                            } else {
                                                                navigate("/video_kyc_pending");
                                                            }

                                                        }}
                                                        className=""> <a href="" className="flex items-center p-4 py-2.5 -mb-px border-t-2 border-transparent aria-expanded:text-black aria-expanded:border-black aria-expanded:dark:text-white aria-expanded:dark:border-white" aria-expanded="false"> <ion-icon className="mr-2 text-2xl" name="pricetags-outline"></ion-icon> Clients Approach </a> </li>
                                                }
                                            </ul>
                                        </nav>

                                    </div>
                                    {/* {
                                        activeTab === 'post_image' &&
                                        <PostImages setPostCount={setPostCount} userId={userData['userId']} />
                                    }

                                    {
                                        activeTab === 'post_video' &&
                                        <PostVideos setTab={setTab} userId={userData['userId']} />
                                    } */}

                                    {
                                        (activeTab === 'post_image' || activeTab === 'post_video') &&
                                        <ArtistMedia setPostCount={setPostCount} userId={userData['userId']} activeTab={activeTab} />
                                    }

                                    {
                                        activeTab === 'client_approache' &&
                                        <ClientApproaches userId={userData['userId']} />
                                    }
                                </div>
                            }
                        </div>
                    }
                    {
                        userData['userType'] === 1 && login &&

                        <div className="mt-10">
                            <div uk-sticky="cls-active: bg-slate-100/60 z-30 backdrop-blur-lg px-4 dark:bg-slate-800/60; start: 500; animation: uk-animation-slide-top" className="uk-sticky">

                                <nav className="text-sm text-center text-gray-500 capitalize font-semibold dark:text-white">
                                    <ul className="flex gap-2 justify-center border-t dark:border-slate-700" uk-switcher="connect: #story_tab ; animation: uk-animation-fade, uk-animation-slide-left-medium">

                                        <li className="uk-active"> <a href=""
                                            onClick={() => {
                                                setTab('events');
                                            }}
                                            className="flex items-center p-4 py-2.5 -mb-px border-t-2 border-transparent aria-expanded:text-black aria-expanded:border-black aria-expanded:dark:text-white aria-expanded:dark:border-white" aria-expanded="true"> <ion-icon className="mr-2 text-2xl" name="camera-outline"></ion-icon> Events  </a> </li>
                                        <li className="uk-active"> <a href=""
                                            onClick={() => {
                                                setTab('adposts');
                                            }}
                                            className="flex items-center p-4 py-2.5 -mb-px border-t-2 border-transparent aria-expanded:text-black aria-expanded:border-black aria-expanded:dark:text-white aria-expanded:dark:border-white" aria-expanded="true"> <ion-icon className="mr-2 text-2xl" name="camera-outline"></ion-icon> Ad Posts  </a> </li>
                                        {
                                            loginId === userData['userId'] &&

                                            <li className=""> <a href=""
                                                onClick={() => {
                                                    setTab('approches');
                                                }} className="flex items-center p-4 py-2.5 -mb-px border-t-2 border-transparent aria-expanded:text-black aria-expanded:border-black aria-expanded:dark:text-white aria-expanded:dark:border-white" aria-expanded="false"> <ion-icon className="mr-2 text-2xl" name="pricetags-outline"></ion-icon> Approaches </a> </li>
                                        }
                                    </ul>
                                </nav>

                            </div>
                            {
                                activeTab === 'events' &&
                                <ClientEventWrap userId={userData['userId']} setEventCount={setEventCount} />
                            }
                            {
                                activeTab === 'adposts' && loginId === userData['userId'] &&
                                <ClientAdPostWrap userId={userData['userId']} />
                            }
                            {
                                activeTab === 'approches' && loginId === userData['userId'] &&
                                <ApproachList userId={userData['userId']} />
                            }
                        </div>
                    }
                </div>
            }
        </main>
        {
            !login &&
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: '#ffffffb4' }}>
                <LoginModel />
            </div>
        }
    </div>
}